/**
 * useWriteAccess Hook
 * Returns whether write operations are allowed based on license status
 * Active licenses allow writes, Expired/Invalid do not
 */

import { useLicense } from './useLicense';

export function useWriteAccess() {
    const { license, isLoading } = useLicense();

    const canWrite = license?.status === 'Active';
    const isReadOnly = license?.status === 'Expired';

    return {
        canWrite,
        isReadOnly,
        isLoading,
        license,
    };
}
